import { render } from "./PacienteCita02.vue?vue&type=template&id=14dc6708&scoped=true"
import script from "./PacienteCita02.vue?vue&type=script&lang=js"
export * from "./PacienteCita02.vue?vue&type=script&lang=js"

import "./PacienteCita02.vue?vue&type=style&index=0&id=14dc6708&scoped=true&lang=css"
import "./PacienteCita02.vue?vue&type=style&index=1&id=14dc6708&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14dc6708"]])

export default __exports__